<xg-header
  [appName]="appName"
  [showSearch]="showSearch"
  (toggleSideNav)="toggleSideNav($event)"
  [home]="home"
>
  <ng-container brandLogo>
    <img src="assets/app_brand_logo.svg" alt="appName" class="brand-icon" />
  </ng-container>

  <ng-container initial>{{ userData?.givenName?.charAt(0) }}</ng-container>
  <ng-container userMenu>
    <div disabled="disabled" mat-menu-item>
      <mat-icon>person</mat-icon>
      {{ userData.givenName }} {{ userData.familyName }}
    </div>
    <div disabled="disabled" mat-menu-item>
      <mat-icon>email</mat-icon>
      <span>{{ userData.emailAddress }}</span>
    </div>
    <a mat-menu-item id="Route-Logout" (click)="logout()">
      <mat-icon>power_settings_new</mat-icon>
      Logout
    </a>
  </ng-container>
</xg-header>
<app-working-alerts></app-working-alerts>
<xg-sidenav
  [navContent]="sideNavContent"
  (toggleChanged)="toggleSideNav($event)"
>
</xg-sidenav>
